import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { Grid } from '@material-ui/core';
import { ContasPagarVisualizar } from 'app/main/contaspagar/container';
import { ContasPagarConsumer, ContasPagarProvider } from 'app/main/contaspagar/store';
import { RecorrenciaProvider } from 'app/main/contaspagar/store/recorrencia';
import { simpleAlert } from 'app/services/alerts';
import conciliacaoApi from 'app/services/api/conciliacaoApi';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useState } from 'react';
import { FaArrowCircleDown } from 'react-icons/fa';
import { ConciliacaoContext } from '../../ConciliacaoContext';
import { ConciliacaoModal } from '../../modal/ConciliacaoModal';
import PesquisaContaPagarForm from './PesquisaContaPagarForm';
import PesquisaContaPagarTable from './PesquisaContaPagarTable';

const PesquisaContaPagarModal = ({ onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useContext(ConciliacaoContext).modal;
  const [extratoSelecionado, setExtratoSelecionado] = useContext(ConciliacaoContext).extratoSelecionado;

  useReduxLoading(loading);

  const close = () => {
    formik.setValues({});
    setModal('');
  };

  const initialValues = {
    situacao: undefined,
    dataVencimentoPagamento: undefined,
    dataLiquidacao: undefined,
    mesCompetencia: undefined,
    formaPagamento: undefined,
    fornecedor: undefined,
    categoria: undefined,
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const montaEstruturaDoLancamento = (conta) => {
    return {
      id: conta.id,
      fornecedor: conta.fornecedor,
      baixas: getBaixa(conta),
      categorias: conta?.categorias,
      valor: getValor(conta),
      formulario: false,
      situacao: conta.situacao,
      contaDivergente: conta.baixas?.some((baixa) => baixa?.conta?.id !== extratoSelecionado.contaBancariaId) || false,
      possuiRetencoes: (!!conta.retencoes && conta.retencoes.length > 0) || !!conta.retencaoDespesaOrigemId,
      retencaoDespesaOrigemId: conta.retencaoDespesaOrigemId,
      parcelamentoDespesaOrigemId: conta.parcelamentoDespesaOrigemId,
      baixaDivergente: isBaixaDivergente(conta),
      numeroParcelas: conta.numeroParcelas,
      parcela: conta.parcela,
      formaPagamento: conta.formaPagamento,
    };
  };

  const verificarBaixa = (baixas) => {
    const baixasFiltradas = baixas?.filter((baixa) => {
      return baixa?.valorPago === Math.abs(extratoSelecionado?.valor);
    });
    return baixasFiltradas;
  };

  const isBaixaDivergente = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas?.length === 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const getBaixa = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas.length > 0) {
        return [
          {
            dataPagamento: baixas[0]?.dataPagamento,
            dataLiquidacao: baixas[0]?.dataLiquidacao,
            valorPago: baixas[0]?.valorPago,
          },
        ];
      }
    }
    if (conta.situacao === 'BAIXADA' && conta?.baixas?.length > 0) {
      let ultimaDataPagamento =
        conta.baixas?.map((baixa) => baixa?.dataPagamento).sort((a, b) => new Date(b) - new Date(a))[0] || null;

      let ultimaDataLiquidacao =
        conta.baixas?.map((baixa) => baixa?.dataLiquidacao).sort((a, b) => new Date(b) - new Date(a))[0] || null;

      let somatorioValoresPagos =
        conta.baixas?.map((baixa) => baixa?.valorPago).reduce((acc, valorPago) => acc + (valorPago || 0), 0) || null;

      return [
        {
          dataPagamento: ultimaDataPagamento,
          dataLiquidacao: ultimaDataLiquidacao,
          valorPago: somatorioValoresPagos,
        },
      ];
    }
  };

  const getValor = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas.length > 0) {
        return baixas[0].valorPago;
      }
    }
    if (conta.situacao === 'BAIXADA' && conta?.baixas?.length > 0) {
      return conta?.baixas?.map((baixa) => baixa.valorPago).reduce((acc, valorPago) => acc + (valorPago || 0), 0);
    }

    return conta?.valorLiquido;
  };

  const possuiDespesaBaixadaSemVinculoComConta = (despesas) => {
    return despesas.some((despesa) => despesa.contaDivergente === true);
  };

  const selecionaDespesasSemDivergencias = (despesas) => {
    const despesasValidas = despesas.filter((despesa) => despesa.contaDivergente === false);

    if (despesasValidas.length > 0) {
      setExtratoSelecionado({
        ...extratoSelecionado,
        contaPagarList: despesasValidas,
      });
    }
    formik.handleSubmit();
  };

  const adicionarDespesaNoExtrato = (despesas) => {
    if (possuiDespesaBaixadaSemVinculoComConta(despesas)) {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar a conta, pois ela foi baixada com uma conta bancária diferente do extrato.',
        },
      });

      /* if (despesas.length === 1) {
        simpleAlert({
          opcoes: {
            title:
              'Não é possível selecionar a conta, pois ela foi baixada com uma conta bancária diferente do extrato.',
          },
        });
      } else {
        confirmarAlert({
          confirmar: () => {
            selecionaDespesasSemDivergencias(despesas);
          },
          titulo:
            'Não é possível selecionar a conta, pois ela foi baixada com uma conta bancária diferente do extrato.',
          mensagem: '',
        });
      } */
    } else if (possuiDespesaComBaixaDivergente(despesas)) {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar a conta, pois o valor diverge do valor registrado no extrato.',
        },
      });
    } else {
      selecionaDespesasSemDivergencias(despesas);
    }
  };

  const possuiDespesaComBaixaDivergente = (despesas) => {
    return despesas.some((despesa) => despesa.baixaDivergente === true);
  };

  const buscaContasFiltroTodos = (contexto) => {
    let despesas = [];
    conciliacaoApi.buscarContaPagarFiltroTodos({ ...contexto.filtroAvancadoFormatado }).then((contas) => {
      if (contas.data.length > 0) {
        let contemContaPagarParcial = contas?.data?.some((conta) => conta?.situacao === 'PARCIAL');
        if (!contemContaPagarParcial) {
          contas.data.forEach((conta) => {
            despesas.push(montaEstruturaDoLancamento(conta));
          });
        } else {
          simpleAlert({
            opcoes: {
              title: 'Não é possível selecionar mais de uma conta quando uma delas estiver com baixa parcial.',
            },
          });
        }
      }
      adicionarDespesaNoExtrato(despesas);
    });
  };

  const buscaContasSelecionadas = (contexto) => {
    let despesas = [];

    let contemContaPagarParcial = contexto.selecionados?.some(
      (conta) => conta?.situacao === 'PARCIAL' && contexto.selecionados?.length > 1
    );
    if (!contemContaPagarParcial) {
      contexto.selecionados.forEach((conta) => {
        despesas.push(montaEstruturaDoLancamento(conta));
      });
      adicionarDespesaNoExtrato(despesas);
    } else {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar mais de uma conta quando uma delas estiver com baixa parcial.',
        },
      });
    }
  };

  const vincularContasComExtrato = async (contexto) => {
    setLoading(true);
    if (contexto.tipoSelecao === 'TODOS_FILTRO') {
      buscaContasFiltroTodos(contexto);
    } else if (contexto?.selecionados?.length > 0) {
      buscaContasSelecionadas(contexto);
    }
    setLoading(false);
  };

  return (
    <>
      {modal === ConciliacaoModal.pesquisaContaPagar ? (
        <RecorrenciaProvider>
          <ContasPagarProvider>
            <ContasPagarConsumer>
              {(context) => {
                return (
                  <>
                    <SimpleDialog
                      fullScreen
                      open={modal === ConciliacaoModal.pesquisaContaPagar}
                      onClose={close}
                      innerScroll
                    >
                      <FormikProvider value={formik}>
                        <FormDialogContent
                          onSubmit={(e) => {
                            vincularContasComExtrato(context);
                          }}
                          fullScreen
                          header={{
                            title: 'Buscar contas a pagar',
                            icon: <FaArrowCircleDown />,
                            toolbar: (
                              <>
                                <CancelButton title="cancelar" type="button" onClick={close}>
                                  Cancelar
                                </CancelButton>
                                <SaveButton color="buttonSave" type="submit" styles={undefined} variant={'contained'}>
                                  Selecionar
                                </SaveButton>
                              </>
                            ),
                          }}
                          content={
                            <>
                              <Grid>
                                <PesquisaContaPagarForm />
                              </Grid>
                              <Grid container>
                                <PesquisaContaPagarTable extratoSelecionado={extratoSelecionado} />
                              </Grid>
                              <ContasPagarVisualizar semAcoes />
                            </>
                          }
                        />
                      </FormikProvider>
                    </SimpleDialog>
                  </>
                );
              }}
            </ContasPagarConsumer>
          </ContasPagarProvider>
        </RecorrenciaProvider>
      ) : null}
    </>
  );
};

export default PesquisaContaPagarModal;
